export const TOOLKIT_PRODUCT_ID = "52f3fa2a-e07b-452f-8ea4-7db812e60c6f";
